import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from "../../../shared/services/navigation.service";
import { BaseService } from "../../../shared/services/base.service";
import { ShareVars } from "../../../shared/services/share.vars";
import {
	CANCEL_BOOKING_IMPOSSIBLE,
	ERROR_MESSAGE_GETTING_DATA,
} from "../../../shared/services/display.messages";
import { HotelService } from "@app/shared/services/hotel.service";
import { environment } from "environments/environment";

declare var QRCode: any;

@Component({
	selector: "app-hotel-b2c-voucher",
	templateUrl: "./hotel-b2c-voucher.component.html",
	styleUrls: ["./hotel-b2c-voucher.component.scss"],
})
export class HotelB2CVoucherComponent implements OnInit {

	showError = false;
	bookingDetails: any;
	agency: any;
	client: any;
	qrcodedata: string = "";

	constructor(
		private hotelService: HotelService,
		private navigationService: NavigationService,
		private baseService: BaseService,
		private route: ActivatedRoute,

	) {
		ShareVars.isBusy = true;
	}

	ngOnInit() {
		const id = this.route.snapshot.params["id"]
		if(id){
			this.getBooking(id)
		}else{
			this.showError = true;
		}	
	}

	getBooking(id) {
		this.hotelService.getHotelBookingById(id).subscribe(
			(response) => {
				ShareVars.isBusy = false;
				if(response){
					this.bookingDetails = response["bookingDetails"];
					this.agency = response["agency"];
					this.client = response["client"];
					this.trimComments();
					if (this.bookingDetails.hotel.info && this.bookingDetails.hotel.info.name) {
						this.bookingDetails.hotel.info.name =
							this.bookingDetails.hotel.info.name.replace(/\u00A0/g, " ");
					}
					this.qrcodedata = this.baseService.getPrintBookingUrl(
						this.bookingDetails.internal_reference,
						this.baseService.getToken(),
						"B2C",
						"HOTEL"
					);
				}
			},
			(err) => {
				console.log(err);
				this.showError = true;
				ShareVars.isBusy = false;
			}
		);
	}

	trimComments() {
		if (this.bookingDetails.comments) {
			this.bookingDetails.comments = this.bookingDetails.comments
				.replace(/(<\/*br\/*>\s*){2,}/gi, "<br>")
				.replace(/^\s*<\/*br\/*>/gi, "");
			this.bookingDetails.comments = this.bookingDetails.comments.replace(
				"<strong><b></b></strong><br>",
				""
			);
		}
	}

	getNights() {
		const oneDay = 24 * 60 * 60 * 1000;
		const firstDate: any = new Date(this.bookingDetails.hotel.checkIn);
		const secondDate: any = new Date(this.bookingDetails.hotel.checkOut);
		return Math.round(Math.abs((firstDate - secondDate) / oneDay));
	}

	uppercaseStr(str: string) {
		return str.toUpperCase();
	}

	formatPrice(price: number): string {
		return this.baseService.formatPrice(price);
	}

	isArabic(): boolean {
		return this.baseService.isArabic();
	}

	goHome(){
        this.navigationService.goToHomePage()
    }

}
